// extracted by mini-css-extract-plugin
module.exports = {"container":"Utilities_ResponsiveVideo_container","player":"Utilities_ResponsiveVideo_player"};